import { FlaggedContactHeaderModel } from '../models/flagged-contact-header.model';
import { FlaggedContactSubContactModel } from '../models/flagged-contact-sub-contact.model';
import { FlaggedContactSubAddressModel } from '../models/flagged-contact-sub-address.model';
import { FlaggedContactSubAliasModel } from '../models/flagged-contact-sub-alias.model';
import { AuditModel } from '../models/audit.model';

export class MockDataHelper {
  static getMockFlaggedContacts(): FlaggedContactHeaderModel[] {
    return [
      {
        contactId: 'CONT001',
        firstName: 'John',
        lastName: 'Smith',
        middleNames: 'Michael',
        address: '123 Main Street',
        city: 'Springfield',
        state: 'IL',
        excludedBy: '',
        dateExcluded: null
      },
      {
        contactId: 'CONT002',
        firstName: 'Maria',
        lastName: 'Rodriguez',
        middleNames: 'Elena',
        address: '456 Oak Avenue',
        city: 'Chicago',
        state: 'IL',
        excludedBy: '',
        dateExcluded: null
      },
      {
        contactId: 'CONT003',
        firstName: 'Robert',
        lastName: 'Johnson',
        middleNames: 'James',
        address: '789 Elm Drive',
        city: 'Peoria',
        state: 'IL',
        excludedBy: '',
        dateExcluded: null
      },
      {
        contactId: 'CONT004',
        firstName: 'Sarah',
        lastName: 'Williams',
        middleNames: 'Elizabeth',
        address: '321 Pine Road',
        city: 'Rockford',
        state: 'IL',
        excludedBy: '',
        dateExcluded: null
      },
      {
        contactId: 'CONT005',
        firstName: 'David',
        lastName: 'Brown',
        middleNames: 'Christopher',
        address: '654 Maple Lane',
        city: 'Naperville',
        state: 'IL',
        excludedBy: '',
        dateExcluded: null
      }
    ];
  }

  static getMockSubContacts(contactId: string): FlaggedContactSubContactModel[] {
    // Return different mock data based on contactId to demonstrate refresh
    const mockData: { [key: string]: FlaggedContactSubContactModel[] } = {
      'CONT001': [
        {
          contactId: contactId,
          firstName: 'John',
          lastName: 'Smith',
          middleNames: 'Michael',
          ofacContactId: '1',
          exclusionId: '',
          addresses: [
            {
              address: '123 Main Street',
              city: 'Springfield'
            },
            {
              address: '456 Alternate Street',
              city: 'Springfield'
            }
          ],
          aliases: [
            {
              firstName: 'Johnny',
              lastName: 'Smith',
              middleNames: 'M'
            },
            {
              firstName: 'J',
              lastName: 'Smith',
              middleNames: 'Michael'
            }
          ],
          audit: null
        },
        {
          contactId: contactId,
          firstName: 'John',
          lastName: 'Smith',
          middleNames: 'M',
          ofacContactId: '2',
          exclusionId: '',
          addresses: [
            {
              address: '789 Different Road',
              city: 'Chicago'
            }
          ],
          aliases: [],
          audit: null
        }
      ],
      'CONT002': [
        {
          contactId: contactId,
          firstName: 'Maria',
          lastName: 'Rodriguez',
          middleNames: 'Elena',
          ofacContactId: '3',
          exclusionId: '',
          addresses: [
            {
              address: '456 Oak Avenue',
              city: 'Chicago'
            }
          ],
          aliases: [
            {
              firstName: 'Mary',
              lastName: 'Rodriguez',
              middleNames: 'E'
            }
          ],
          audit: null
        }
      ],
      'CONT003': [
        {
          contactId: contactId,
          firstName: 'Robert',
          lastName: 'Johnson',
          middleNames: 'James',
          ofacContactId: '4',
          exclusionId: '',
          addresses: [
            {
              address: '789 Elm Drive',
              city: 'Peoria'
            },
            {
              address: '321 Oak Street',
              city: 'Peoria'
            }
          ],
          aliases: [
            {
              firstName: 'Bob',
              lastName: 'Johnson',
              middleNames: 'J'
            },
            {
              firstName: 'Rob',
              lastName: 'Johnson',
              middleNames: 'James'
            }
          ],
          audit: null
        }
      ],
      'CONT004': [
        {
          contactId: contactId,
          firstName: 'Sarah',
          lastName: 'Williams',
          middleNames: 'Elizabeth',
          ofacContactId: '5',
          exclusionId: '',
          addresses: [
            {
              address: '321 Pine Road',
              city: 'Rockford'
            }
          ],
          aliases: [],
          audit: null
        }
      ],
      'CONT005': [
        {
          contactId: contactId,
          firstName: 'David',
          lastName: 'Brown',
          middleNames: 'Christopher',
          ofacContactId: '6',
          exclusionId: '',
          addresses: [
            {
              address: '654 Maple Lane',
              city: 'Naperville'
            },
            {
              address: '987 Cedar Court',
              city: 'Naperville'
            }
          ],
          aliases: [
            {
              firstName: 'Dave',
              lastName: 'Brown',
              middleNames: 'C'
            }
          ],
          audit: null
        }
      ]
    };

    return mockData[contactId] || [
      {
        contactId: contactId,
        firstName: 'Unknown',
        lastName: 'Contact',
        middleNames: '',
        ofacContactId: '0',
        exclusionId: '',
        addresses: [],
        aliases: [],
        audit: null
      }
    ];
  }

  static getMockAuditRecords(sourceId: string): AuditModel[] {
    return [
      {
        contactId: 'CONT001',
        ofacContactId: 1,
        sourceId: sourceId,
        contactName: 'John Michael Smith',
        applicationName: 'Test Application',
        ofacMatchTypeId: 1,
        createdDate: new Date(),
        confidence: '95%',
        searchJson: '{"firstName":"John","lastName":"Smith"}',
        resultJson: '{"matches":[{"name":"John Smith","score":0.95}]}'
      },
      {
        contactId: 'CONT002',
        ofacContactId: 2,
        sourceId: sourceId,
        contactName: 'Maria Elena Rodriguez',
        applicationName: 'Test Application',
        ofacMatchTypeId: 1,
        createdDate: new Date(),
        confidence: '88%',
        searchJson: '{"firstName":"Maria","lastName":"Rodriguez"}',
        resultJson: '{"matches":[{"name":"Maria Rodriguez","score":0.88}]}'
      },
      {
        contactId: 'CONT003',
        ofacContactId: 3,
        sourceId: sourceId,
        contactName: 'Robert James Johnson',
        applicationName: 'Test Application',
        ofacMatchTypeId: 1,
        createdDate: new Date(),
        confidence: '92%',
        searchJson: '{"firstName":"Robert","lastName":"Johnson"}',
        resultJson: '{"matches":[{"name":"Robert Johnson","score":0.92}]}'
      },
      {
        contactId: 'CONT004',
        ofacContactId: 4,
        sourceId: sourceId,
        contactName: 'Sarah Elizabeth Williams',
        applicationName: 'Test Application',
        ofacMatchTypeId: 1,
        createdDate: new Date(),
        confidence: '87%',
        searchJson: '{"firstName":"Sarah","lastName":"Williams"}',
        resultJson: '{"matches":[{"name":"Sarah Williams","score":0.87}]}'
      },
      {
        contactId: 'CONT005',
        ofacContactId: 5,
        sourceId: sourceId,
        contactName: 'David Christopher Brown',
        applicationName: 'Test Application',
        ofacMatchTypeId: 1,
        createdDate: new Date(),
        confidence: '91%',
        searchJson: '{"firstName":"David","lastName":"Brown"}',
        resultJson: '{"matches":[{"name":"David Brown","score":0.91}]}'
      },
      {
        contactId: 'CONT001',
        ofacContactId: 6,
        sourceId: sourceId,
        contactName: 'John Michael Smith',
        applicationName: 'Test Application 2',
        ofacMatchTypeId: 1,
        createdDate: new Date(),
        confidence: '89%',
        searchJson: '{"firstName":"John","lastName":"Smith"}',
        resultJson: '{"matches":[{"name":"John M Smith","score":0.89}]}'
      }
    ];
  }
}

